  (function () {
    if (window.__sizeFitModalInit) return;
    window.__sizeFitModalInit = true;

    // Modal references are re-bound lazily so this module works
    // whether the modal markup is present at page load (normal PDP)
    // or injected via AJAX later (quick-view on collection page).
    // `bindModal()` is called at page load and again on the first
    // click on a `[data-open-size-fit]` trigger if no modal was
    // bound yet.
    var modal, tabs, panels, chartHost, truefitHost;
    function bindModal() {
      modal = document.querySelector('[data-size-fit-modal]');
      if (!modal) return false;

      // Teleport to <body>. When the modal is rendered inside the
      // quick-view's AJAX container (or any ancestor with a CSS
      // `transform`, `filter`, `perspective`, or `will-change`
      // declaration — which quick-view's animation wrappers have),
      // `position: fixed` descendants are contained by that
      // ancestor instead of the viewport (CSS spec). Result was the
      // size-fit modal rendering UNDER the quick-view sheet instead
      // of overlaying it. Moving the modal element up to <body>
      // short-circuits the whole class of problem — same fix we
      // use for the mobile sticky ATC. Safe to call multiple times;
      // appendChild is a no-op if already a direct child of body.
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      tabs = modal.querySelectorAll('[data-size-fit-tab]');
      panels = modal.querySelectorAll('[data-size-fit-panel]');
      chartHost = modal.querySelector('[data-size-fit-chart-host]');
      truefitHost = modal.querySelector('[data-size-fit-truefit-host]');
      return true;
    }
    bindModal(); // best-effort at load; may be null on collection pages

    // External reset hook (lookbook / Shop the Look uses this to swap in a
    // per-product size-fit modal between clicks). Clears the cached modal
    // refs so the next click triggers a fresh `bindModal()`.
    window.__sizeFitResetModal = function () {
      // Detach the currently bound modal if it's no longer in the DOM
      // (caller has typically just removed it). Safe to call regardless.
      modal = null;
      tabs = null;
      panels = null;
      chartHost = null;
      truefitHost = null;
      kiwiEmbedded = false;
      kiwiLiveNode = null;
      lastEmbeddedProductId = null;
    };

    // ── Kiwi state (clone approach — original node is NEVER moved) ───────
    var kiwiEmbedded = false;
    var kiwiLiveNode = null;   // reference to Kiwi's .ks-modal-content-wrapper

    // ── Tab switching ─────────────────────────────────────────────────────
    function setTab(name) {
      tabs.forEach(function (t) {
        var active = t.getAttribute('data-size-fit-tab') === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-size-fit-panel') === name);
      });
      if (name === 'truefit') embedTrueFitIntoHost();
    }

    // ═══════════════════════════════════════════════════════════════════════
    //  KIWI SIZING — clone strategy
    //
    //  Why clone, not move:
    //    Moving .ks-modal-content-wrapper out of Kiwi's parent detaches the
    //    node from the context Kiwi's event handlers expect. When the user
    //    toggles CM/INCHES, Kiwi re-renders into its original (now vacated)
    //    parent, leaving our host empty.
    //
    //  Solution:
    //    1. Click Kiwi's trigger so it populates its content wrapper.
    //    2. Directly click the "Size Chart" tab in Kiwi's LIVE node so the
    //       chart table renders there.
    //    3. cloneNode(true) that populated state into chartHost.
    //    4. Strip unwanted chrome from the clone.
    //    5. For interactivity (CM/INCHES toggle): intercept clicks on the
    //       clone, forward them to the matching button in the live node,
    //       then re-clone after Kiwi re-renders (~350 ms).
    // ═══════════════════════════════════════════════════════════════════════

    function embedKiwiIntoHost() {
      if (kiwiEmbedded) return;
      document.body.setAttribute('data-size-fit-open', '1');

      // Kiwi loads its scripts asynchronously — .ks-chart-modal-link may not
      // exist in the DOM yet when the user opens our modal. Poll for it (up to
      // 3 s), click it once it appears, then poll for the content to populate.
      var triggered = false;
      var tries     = 0;
      var timer     = setInterval(function () {
        tries++;

        // ── Phase 1: wait for Kiwi's trigger to be injected ──────────────
        if (!triggered) {
          var trigger = document.querySelector('.sizing-chart-modal-link, .ks-chart-modal-link');
          if (!trigger) {
            // 6 s. Was 3 s — too short when Kiwi is loaded async via
            // app-embed (common on collection pages) AND we just
            // called `loadSizing()` with a new product's data. Kiwi
            // fetches over the network before injecting the link.
            if (tries > 120) {
              clearInterval(timer);
              var haveKiwi = !!(window.ks && typeof window.ks.loadSizing === 'function');
              var msg = haveKiwi
                ? 'Size chart unavailable for this product.'
                : 'Size chart app not available on this page.';
              chartHost.innerHTML = '<p class="size-fit-modal__error">' + msg + '</p>';
              console.warn('[size-fit] Phase 1 timeout. window.ks ready:', haveKiwi);
            }
            return;   // keep polling
          }
          trigger.click();
          triggered = true;
          tries = 0;  // reset counter for phase 2
          return;
        }

        // ── Phase 2: wait for .ks-modal-content-wrapper to be populated ──
        // Explicitly exclude any wrapper already inside chartHost (a stale
        // clone from a previous open) so we always get Kiwi's live node.
        var allWrappers = document.querySelectorAll('.ks-modal-content-wrapper');
        var c = null;
        for (var wi = 0; wi < allWrappers.length; wi++) {
          if (!chartHost.contains(allWrappers[wi])) { c = allWrappers[wi]; break; }
        }
        if (c && (c.textContent || '').trim().length > 20) {
          clearInterval(timer);
          kiwiLiveNode = c;
          activateKiwiSizeChartTab(c, function () {
            kiwiEmbedded = true;
            cloneKiwiIntoHost();
            document.body.style.overflow = 'hidden';
          });
          return;
        }
        if (tries > 80) {   // 4 s — content never appeared
          clearInterval(timer);
          if (!kiwiEmbedded) {
            console.warn('[size-fit] Kiwi content never populated');
            chartHost.innerHTML = '<p class="size-fit-modal__error">Could not load size chart. Please refresh.</p>';
          }
        }
      }, 50);
    }

    /**
     * Click the "Size Chart" tab inside the live Kiwi node.
     * Kiwi's tabs are <div class="ks-modal-tab"> elements — not buttons/anchors.
     * The chart content is pre-rendered (just CSS-hidden), so a fixed 150 ms
     * wait for Kiwi's class toggle is enough before we clone.
     */
    function activateKiwiSizeChartTab(liveNode, cb) {
      var tabs = liveNode.querySelectorAll('.ks-modal-tab, [class*="ks-modal-tab"]');
      var chartTabEl = null;
      for (var i = 0; i < tabs.length; i++) {
        if (/^size\s*chart$/i.test((tabs[i].textContent || '').trim())) {
          chartTabEl = tabs[i]; break;
        }
      }
      if (chartTabEl) chartTabEl.click();
      // Fixed wait — chart rows are pre-rendered, Kiwi only toggles CSS classes
      setTimeout(cb, 150);
    }

    /**
     * Snapshot the live Kiwi content into chartHost, attach proxy clicks.
     * Safe to call multiple times (re-clones after a unit toggle).
     *
     * WHY selective clone, not full wrapper:
     *   Kiwi collapses .ks-modal-content-wrapper and several ancestor
     *   divs to height:0/overflow:hidden in its "closed" CSS state. Even
     *   with height:auto !important on the clone, the cascade of h:0 on
     *   intermediate elements (enforced by Kiwi's !important rules) means
     *   the wrapper clone never gains visible height.
     *
     *   Instead we clone only the two sub-elements that already have
     *   natural height in the live node:
     *     1. .ks-modal-tab-wrapper  — Metric / Imperial toggle
     *     2. .ks-chart-tab-container — the actual size table
     *   Both are force-displayed with inline !important overrides so
     *   Kiwi's closed-state CSS can't collapse them.
     */
    /*
      Locate Kiwi's CM / Inches toggle without relying on any specific
      class name. Different Kiwi accounts export different class
      names (`.ks-modal-tab-wrapper`, `.ks-unit-toggle-wrapper`, bare
      div with a <ul>) so text-content detection is more reliable.
      Strategy: find the smallest ancestor that contains BOTH "CM"
      and "INCH" text, bailing out at the table boundary (the chart
      itself contains neither).
    */
    function findKiwiUnitToggle(root) {
      if (!root) return null;
      /*
        CRITICAL: `.ks-modal-tab-wrapper` is Kiwi's OUTER tab bar
        — it contains the "Calculate My Size" / "Size Chart"
        section toggle, NOT the CM/INCHES unit toggle. Live DOM
        inspection (2026-04-22) confirmed `.ks-unit-toggle-wrapper`
        is the actual unit toggle. Matching `.ks-modal-tab-wrapper`
        first was cloning the wrong element; the result was a tiny
        6-px wide clone whose text was "Calculate My SizeSize
        Chart" — user-visible symptom: the CM|INCHES reads as
        "still centred" because there's nothing visible in the
        wrapper we injected.
      */
      var known = root.querySelector('.ks-unit-toggle-wrapper, .ks-unit-toggle');
      if (known) return known;
      // Text-content fallback: walk all elements, find the smallest
      // element whose textContent contains BOTH "CM" and "INCH".
      var candidates = root.querySelectorAll('*:not(table):not(tr):not(td):not(th)');
      var best = null;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var txt = (el.textContent || '').toUpperCase();
        if (txt.indexOf('CM') === -1 || txt.indexOf('INCH') === -1) continue;
        if (!best || el.children.length <= best.children.length) best = el;
      }
      return best;
    }

    /*
      Transpose a row-oriented Kiwi chart (sizes in the first
      column: "Size | XXS | XS | S | ...") to Represent's column-
      oriented format (sizes as header cells across the top:
      "| XXS | XS | S | ..." with measurements running down).

      Detection: score both axes against `collectCandidateSizes()`.
      If the first COLUMN has more size matches than the header
      ROW, it's row-oriented and we transpose. Otherwise leave as-is.

      Idempotent — safe to call on every re-clone. Silent no-op
      if no table, no candidate sizes, or the detected orientation
      is already column-oriented.
    */
    function normaliseChartOrientation(chartClone) {
      if (!chartClone) return;
      var tables = chartClone.querySelectorAll('table');
      if (!tables.length) return;
      var sizes = collectCandidateSizes();
      if (!Object.keys(sizes).length) return;

      tables.forEach(function (table) {
        var rows = table.rows;
        if (!rows || rows.length < 2) return;

        // Score header row (cells 1..N of row 0)
        var headerMatches = 0;
        for (var i = 1; i < rows[0].cells.length; i++) {
          var t = (rows[0].cells[i].textContent || '').trim().toUpperCase();
          if (sizes[t]) headerMatches++;
        }
        // Score first column (cell 0 of rows 1..N)
        var colMatches = 0;
        for (var j = 1; j < rows.length; j++) {
          if (!rows[j].cells[0]) continue;
          var ft = (rows[j].cells[0].textContent || '').trim().toUpperCase();
          if (sizes[ft]) colMatches++;
        }
        // Already column-oriented → nothing to do.
        if (headerMatches >= colMatches) return;

        // Extract the 2D grid of textContent + tag, then rebuild
        // a transposed table. Preserve `<th>` for the header row
        // and the row-label column so semantic styling holds.
        var grid = [];
        var maxCols = 0;
        for (var r = 0; r < rows.length; r++) {
          var row = [];
          for (var c = 0; c < rows[r].cells.length; c++) {
            var cell = rows[r].cells[c];
            row.push({ text: cell.innerHTML, tag: cell.tagName });
          }
          grid.push(row);
          if (row.length > maxCols) maxCols = row.length;
        }

        // Build the transposed grid: new_row[i] = original col[i]
        var transposed = [];
        for (var c2 = 0; c2 < maxCols; c2++) {
          var newRow = [];
          for (var r2 = 0; r2 < grid.length; r2++) {
            var src = grid[r2][c2] || { text: '', tag: 'TD' };
            newRow.push(src);
          }
          transposed.push(newRow);
        }

        // Rebuild the table DOM. Header row (transposed[0]) uses
        // <th>; first column of subsequent rows also uses <th>
        // so row labels stay semantic. Inner data cells are <td>.
        var newTbody = document.createElement('tbody');
        for (var rr = 0; rr < transposed.length; rr++) {
          var tr = document.createElement('tr');
          for (var cc = 0; cc < transposed[rr].length; cc++) {
            var isHeaderRow = rr === 0;
            var isFirstCol = cc === 0;
            var tag = (isHeaderRow || isFirstCol) ? 'th' : 'td';
            var cellEl = document.createElement(tag);
            cellEl.innerHTML = transposed[rr][cc].text;
            tr.appendChild(cellEl);
          }
          newTbody.appendChild(tr);
        }

        // Wipe existing rows + tbody/thead and attach the new tbody.
        while (table.firstChild) table.removeChild(table.firstChild);
        table.appendChild(newTbody);
      });

      /*
        Kiwi measurement row labels are stored as Title Case or
        UPPERCASE depending on the admin's data-entry style. The
        reference Represent chart uses Title Case ("Size",
        "Shoulder", "Sleeve Length") — which reads lighter than
        all-caps. Pass once over the first column of each table
        and convert to Title Case only when the label is fully
        uppercase. Multi-word handled naïvely — sufficient for
        garment-measurement terms.
      */
      var tables2 = chartClone.querySelectorAll('table');
      tables2.forEach(function (tbl) {
        for (var r = 0; r < tbl.rows.length; r++) {
          var firstCell = tbl.rows[r].cells[0];
          if (!firstCell) continue;
          var txt = (firstCell.textContent || '').trim();
          if (!txt) continue;
          // Skip if already Title Case / mixed — only rewrite if ALL UPPERCASE.
          if (txt === txt.toUpperCase() && txt !== txt.toLowerCase()) {
            var titled = txt.toLowerCase().replace(/(^|\s)(\w)/g, function (_, pre, ch) { return pre + ch.toUpperCase(); });
            firstCell.textContent = titled;
          }
        }
      });
    }

    function cloneKiwiIntoHost() {
      if (!kiwiLiveNode) return;
      chartHost.innerHTML = '';

      /*
        Kiwi's `.ks-chart-tab-container` ALREADY contains its own
        CM/INCHES toggle (`.ks-unit-toggle-wrapper` with text
        "cm/inches"). Previous iterations cloned a SEPARATE toggle
        from the live node as a sibling — but `findKiwiUnitToggle`
        would pick up a DIFFERENT unit-toggle-wrapper variant
        elsewhere in Kiwi's DOM with text "Metric/Imperial" — so
        the modal ended up with TWO visible toggles (mine saying
        "Metric Imperial" floated right, Kiwi's saying "CM | INCHES"
        centred inside the chart). Simpler: clone ONLY the chart
        container (which includes the toggle), then CSS right-
        aligns the inner `.ks-unit-toggle-wrapper`.
      */
      var liveChart = kiwiLiveNode.querySelector('.ks-chart-tab-container');
      if (liveChart) {
        var chartClone = liveChart.cloneNode(true);
        chartClone.style.cssText =
          'display:block !important; height:auto !important; overflow:visible !important; margin:0 !important; padding:0 !important;';
        chartHost.appendChild(chartClone);

        /*
          Normalise chart orientation to Represent's format —
          SIZES across the top as column headers, MEASUREMENTS
          as row labels down the left. Kiwi exports either shape
          depending on how the merchandiser built the chart
          template; we transpose row-oriented tables so the
          modal feels consistent across products.
        */
        normaliseChartOrientation(chartClone);

        /*
          User feedback: "This piece is intended to fit oversized"
          (Kiwi's `.ks-html-content` note) lives BELOW the chart by
          default, leaving a big empty gap between chart and ADD-TO-
          BAG. Move it inline with the CM/INCHES toggle: same row,
          note on the LEFT, toggle on the RIGHT. Kills the whitespace
          above the CTA and gives the note immediate context.
        */
        var toggle = chartClone.querySelector('.ks-unit-toggle-wrapper');
        var note = chartClone.querySelector('.ks-html-content');
        if (toggle && note) {
          var headerRow = document.createElement('div');
          headerRow.className = 'size-fit-modal__chart-header';
          // Move note first (left), toggle second (right).
          headerRow.appendChild(note);
          headerRow.appendChild(toggle);
          // Insert at the very top of the chart clone so it sits
          // above the table regardless of Kiwi's original order.
          chartClone.insertBefore(headerRow, chartClone.firstChild);
        }
      } else {
        // Fallback: clone whole wrapper if Kiwi's structure changed.
        var fallback = kiwiLiveNode.cloneNode(true);
        fallback.style.cssText =
          'display:block !important; visibility:visible !important; height:auto !important; overflow:visible !important;';
        chartHost.appendChild(fallback);
        stripKiwiChrome(chartHost);
      }

      setupKiwiProxyClicks(chartHost, kiwiLiveNode);
      applySizeColumnHighlight();
    }

    // ═══════════════════════════════════════════════════════════════════════
    //  ACTIVE-SIZE COLUMN HIGHLIGHT — Plan B parity with Represent
    //
    //  After the chart is cloned into chartHost, find the column whose
    //  header cell matches the currently-selected size pill and tag every
    //  cell in that column with `.is-active-size-col`. Mark every OTHER
    //  cell in the data rows with `.is-inactive-size-col` so the active
    //  column stands out via a muted bg + darker weight while peers dim.
    //
    //  Guards:
    //    • No table → no-op.
    //    • Header cells missing / no text match → no-op (not every product
    //      uses a Size-primary chart; we silently tolerate and dim nothing).
    //    • Variant pickers with non-size primary option → same silent
    //      no-op, since `readSelectedSize()` returns '' when no size
    //      pill is found.
    // ═══════════════════════════════════════════════════════════════════════

    /*
      On this theme the PDP size picker renders as
      `.product__color-swatch.dynamic-variant-button` buttons
      (not `.product__chip` — that was the sub-agent's wrong
      assumption based on an older theme version). Live DOM
      probe 2026-04-22 confirmed the swatch class. Keep
      `.product__chip` in the query as a legacy fallback so we
      don't break if the theme reverts.
    */
    var PDP_PILL_SELECTOR =
      '.product__color-swatch.selected, ' +
      '[data-product-option] .product__color-swatch.selected, ' +
      '.product__size-pills .product__chip.selected, ' +
      '[data-product-option] .product__chip.selected';
    var PDP_PILL_SELECTOR_ANY =
      '.product__color-swatch.dynamic-variant-button, ' +
      '[data-product-option] .product__color-swatch, ' +
      '.product__size-pills .product__chip, ' +
      '[data-product-option] .product__chip';

    function readSelectedSize() {
      // Lookbook context → the companion's radio carries the size.
      if (modal && modal.getAttribute('data-context') === 'lookbook' && window.__sizeFitCompanionEl) {
        var checked = window.__sizeFitCompanionEl.querySelector('input[type="radio"][name*="variant"]:checked');
        if (checked) {
          var lab = checked.nextElementSibling;
          var t = lab ? (lab.textContent || '').trim().toUpperCase() : '';
          if (t) return t;
        }
        return '';
      }
      var selectedPill = document.querySelector(PDP_PILL_SELECTOR);
      if (selectedPill) {
        var val = (selectedPill.getAttribute('data-option-value') || selectedPill.textContent || '').trim();
        if (val) return val.toUpperCase();
      }
      var nativeSel = document.querySelector('[data-product-form] select[name*="option" i]');
      if (nativeSel && nativeSel.value) return nativeSel.value.trim().toUpperCase();
      return '';
    }

    /*
      Build the set of size values available on the current product
      context (PDP pills OR lookbook radios). Used to decide whether
      a given table cell contains a "size token" we should make
      clickable. Relying only on "matches the currently-selected
      size" was too strict — if the selected size isn't on the chart
      yet, no cells got tagged and the chart became non-interactive.
    */
    function collectCandidateSizes() {
      var set = Object.create(null);
      var pills = document.querySelectorAll(PDP_PILL_SELECTOR_ANY);
      pills.forEach(function (p) {
        var a = (p.getAttribute('data-option-value') || '').trim().toUpperCase();
        var t = (p.textContent || '').trim().toUpperCase();
        if (a) set[a] = 1;
        if (t) set[t] = 1;
      });
      // Lookbook companion radios also count — their label span is
      // the size value (see main-product--default.liquid line 1277).
      var radios = document.querySelectorAll('.lookbook-product input[type="radio"][name*="variant"]');
      radios.forEach(function (r) {
        var lab = r.nextElementSibling;
        var t = lab ? (lab.textContent || '').trim().toUpperCase() : '';
        if (t) set[t] = 1;
      });
      return set;
    }

    function applySizeColumnHighlight() {
      if (!chartHost) return;
      var size = readSelectedSize();

      // Always clear previous marks before (maybe) re-applying.
      chartHost.querySelectorAll('.is-active-size-col, .is-inactive-size-col, [data-size-fit-pick]').forEach(function (el) {
        el.classList.remove('is-active-size-col', 'is-inactive-size-col');
        el.removeAttribute('data-size-fit-pick');
      });

      var tables = chartHost.querySelectorAll('table');
      if (!tables.length) return;

      var candidateSizes = collectCandidateSizes();

      tables.forEach(function (table) {
        var rows = table.rows;
        if (!rows || !rows.length) return;

        /*
          Detect chart orientation. Kiwi's exported HTML varies:
            • Column-mode — sizes live in the header ROW
              (first row's 2..N cells: e.g. "SIZE" | "XS" | "S" | "M").
              Rastah's hoodies currently export this shape in the
              lookbook context.
            • Row-mode — sizes live in the FIRST COLUMN of every
              data row (e.g. first row is "SIZE" "CHEST" "SLEEVE",
              subsequent rows start with "XXS", "XS", etc.).
              Rastah's main PDP exports this shape.
          We score both axes against `candidateSizes`; the one with
          more matches wins. Ties default to row-mode because that's
          the common pattern on the main PDP here.
        */
        var firstRowCells = rows[0].cells;
        var firstColMatches = 0;
        var headerRowMatches = 0;

        // Header row score: cells 1..N in row 0
        for (var i = 1; i < firstRowCells.length; i++) {
          var t = (firstRowCells[i].textContent || '').trim().toUpperCase();
          if (candidateSizes[t]) headerRowMatches++;
        }
        // First col score: row[1..N][0]
        for (var j = 1; j < rows.length; j++) {
          var firstCell = rows[j].cells[0];
          if (!firstCell) continue;
          var ft = (firstCell.textContent || '').trim().toUpperCase();
          if (candidateSizes[ft]) firstColMatches++;
        }

        var orientation = headerRowMatches > firstColMatches ? 'col' : 'row';

        if (orientation === 'col') {
          // Sizes in header row — highlight COLUMN whose header text
          // equals the currently-selected size. Mark EVERY cell in a
          // size column as clickable (`data-size-fit-pick`) so the
          // whole column acts as a tap target — user feedback:
          // "tapping on any cell should select the column accordingly."
          var targetCol = -1;
          var sizeCols = []; // 1-indexed column indices that carry a size
          for (var hc = 1; hc < firstRowCells.length; hc++) {
            var htxt = (firstRowCells[hc].textContent || '').trim();
            var htxtU = htxt.toUpperCase();
            if (candidateSizes[htxtU]) {
              sizeCols.push({ idx: hc, label: htxt });
            }
            if (size && htxtU === size) targetCol = hc;
          }
          // Tag every row's cells in each size column — header + data.
          sizeCols.forEach(function (col) {
            for (var rrr = 0; rrr < rows.length; rrr++) {
              var cell = rows[rrr].cells[col.idx];
              if (cell) cell.setAttribute('data-size-fit-pick', col.label);
            }
          });
          if (targetCol !== -1) {
            for (var rr = 0; rr < rows.length; rr++) {
              for (var cc = 0; cc < rows[rr].cells.length; cc++) {
                if (cc === targetCol) {
                  rows[rr].cells[cc].classList.add('is-active-size-col');
                } else if (cc !== 0 && rr >= 0) {
                  rows[rr].cells[cc].classList.add('is-inactive-size-col');
                }
              }
            }
          }
        } else {
          // Sizes in first column — highlight ROW whose first cell
          // equals the currently-selected size. Mark every first-
          // column size-cell as clickable.
          var targetRow = -1;
          for (var rj = 1; rj < rows.length; rj++) {
            var fc = rows[rj].cells[0];
            if (!fc) continue;
            var ftxt = (fc.textContent || '').trim();
            var ftxtU = ftxt.toUpperCase();
            if (candidateSizes[ftxtU]) {
              fc.setAttribute('data-size-fit-pick', ftxt);
            }
            if (size && ftxtU === size) targetRow = rj;
          }
          if (targetRow !== -1) {
            for (var rk = 1; rk < rows.length; rk++) {
              var cells = rows[rk].cells;
              if (!cells || !cells.length) continue;
              if (rk === targetRow) {
                for (var ck = 0; ck < cells.length; ck++) {
                  cells[ck].classList.add('is-active-size-col');
                }
              } else {
                for (var ck2 = 1; ck2 < cells.length; ck2++) {
                  cells[ck2].classList.add('is-inactive-size-col');
                }
              }
            }
          }
        }
      });
    }

    /*
      Click a size cell inside the chart → select the matching
      size on the current product context:
        • primary PDP context — click the matching
          `.product__color-swatch` (legacy fallback: `.product__chip`)
          on the size-pill row, which cascades through Stiletto's
          variant-change handlers (fires `product:variant-change`
          → `applySizeColumnHighlight()` repaints + `syncCta()`
          updates the CTA label).
        • lookbook context — click the companion-product's matching
          `<input type="radio">` so the companion's own selection
          state updates and our CTA re-syncs via the document-level
          `change` listener.

      Capture-phase listener because Kiwi attaches its own click
      handlers to table cells and calls `stopPropagation()`,
      which meant our bubble-phase listener never received the
      event (confirmed via live DOM probe: debug listener in
      bubble phase never fired, clicks had no effect on the PDP).
    */
    document.addEventListener('click', function (e) {
      if (!modal || modal.hidden) return;
      var cell = e.target.closest('[data-size-fit-pick]');
      if (!cell || !chartHost.contains(cell)) return;
      var want = (cell.getAttribute('data-size-fit-pick') || '').trim().toUpperCase();
      if (!want) return;
      e.preventDefault();

      // Lookbook context: drive the companion's radio.
      if (modal.getAttribute('data-context') === 'lookbook') {
        var comp = window.__sizeFitCompanionEl;
        if (!comp) return;
        var radios = comp.querySelectorAll('input[type="radio"][name*="variant"]');
        for (var r = 0; r < radios.length; r++) {
          var lab = radios[r].nextElementSibling;
          var val = lab ? (lab.textContent || '').trim().toUpperCase() : '';
          if (val === want && !radios[r].disabled) {
            radios[r].checked = true;
            radios[r].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
        applySizeColumnHighlight();
        return;
      }

      // Primary PDP context: click the size pill.
      var pills = document.querySelectorAll(PDP_PILL_SELECTOR_ANY);
      for (var p = 0; p < pills.length; p++) {
        var byAttr = (pills[p].getAttribute('data-option-value') || '').trim().toUpperCase();
        var byText = (pills[p].textContent || '').trim().toUpperCase();
        if ((byAttr === want || byText === want) && !(pills[p].getAttribute('data-size-sold-out') === 'true')) {
          pills[p].click();
          break;
        }
      }
    }, true);
    // ↑ capture phase — Kiwi stops propagation on cell clicks

    // Re-apply when the variant changes. The chart table itself doesn't
    // re-render for a size swap (same chart, different highlighted
    // column), so we just toggle classes — no re-clone.
    document.addEventListener('product:variant-change', function () {
      applySizeColumnHighlight();
    });

    /**
     * Strip unwanted chrome from the cloned Kiwi content:
     *   • "Calculate My Size" and "Size Chart" tab buttons — hidden (our own
     *     modal tabs already label these).
     *   • Kiwi's internal close button — hidden (we have our own).
     *   • Duplicate product-title header — hidden.
     *
     * Does NOT click any tabs — the live node was activated before cloning,
     * so the chart content is already in the correct state.
     */
    function stripKiwiChrome(host) {
      // Product title was previously injected via Liquid
      // (`{{ product.title | json }}`). Now read from a data attribute
      // on the modal so this script can live as a static asset loaded
      // once in layout/theme.liquid. That avoids the
      // "inline <script> in AJAX-injected HTML doesn't execute" issue
      // that broke Size & Fit inside the quick-view modal on collection
      // pages.
      var productTitle = (modal && modal.dataset && modal.dataset.productTitle) || '';
      if (!productTitle) return;
      var titleRe = new RegExp(
        '^' + productTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').trim() + '$', 'i'
      );

      function directText(el) {
        return Array.from(el.childNodes)
          .filter(function (n) { return n.nodeType === 3; })
          .map(function (n) { return n.textContent.trim(); })
          .join(' ').trim() || (el.textContent || '').trim();
      }
      function closestTabLike(el) {
        // Kiwi's tabs are .ks-modal-tab DIVs — include them explicitly
        return el.closest(
          'li, [role="tab"], [role="presentation"], button, a, ' +
          '.ks-modal-tab, .ks-tab, [class*="tab"]:not([class*="tabs"])'
        ) || el;
      }
      function closestHeaderLike(el) {
        return el.closest('.ks-modal-header, [class*="modal-header"], [class*="header"]') || el;
      }

      var all = host.querySelectorAll('*');
      var tabsToHide = [];
      for (var i = 0; i < all.length; i++) {
        var el  = all[i];
        var txt = directText(el);
        if (!txt || txt.length > 60) continue;

        if (/^calculate\s*my\s*size$/i.test(txt) || /^size\s*chart$/i.test(txt)) {
          tabsToHide.push(closestTabLike(el));
          continue;
        }
        if (titleRe.test(txt)) {
          var hdr = closestHeaderLike(el);
          (hdr && hdr !== host ? hdr : el).style.setProperty('display', 'none', 'important');
        }
      }
      tabsToHide.forEach(function (el) {
        if (el) el.style.setProperty('display', 'none', 'important');
      });
      host.querySelectorAll('.ks-modal-close, [class*="modal-close"]').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }

    /**
     * Proxy clicks from the clone to the matching element in the live Kiwi
     * node, then re-clone after Kiwi re-renders.
     *
     * Critical: the CM/INCHES toggle elements are plain <div class="ks-unit-toggle-label">
     * (not buttons or anchors), so we must include them in the selector.
     * Kiwi's tab elements are <div class="ks-modal-tab"> — same story.
     */
    function setupKiwiProxyClicks(cloneRoot, liveRoot) {
      var proxySelector =
        'button, a, [role="tab"], [role="button"], ' +
        '.ks-modal-tab, .ks-unit-toggle-label, ' +
        '[class*="ks-tab"], [class*="tab-item"]';

      cloneRoot.addEventListener('click', function (e) {
        var cloneEl = e.target.closest(proxySelector);
        if (!cloneEl) return;
        e.preventDefault();
        e.stopPropagation();

        var text = (cloneEl.textContent || '').trim();
        var liveEls = liveRoot.querySelectorAll(proxySelector);
        var liveEl = null;
        for (var i = 0; i < liveEls.length; i++) {
          if ((liveEls[i].textContent || '').trim() === text) { liveEl = liveEls[i]; break; }
        }
        if (liveEl) {
          liveEl.click();
          // Wait for Kiwi to re-render (CSS class toggle + any async update)
          setTimeout(function () {
            if (kiwiEmbedded && kiwiLiveNode) cloneKiwiIntoHost();
          }, 350);
        }
      });
    }

    function restoreKiwi() {
      // Close Kiwi's native modal BEFORE we drop the CSS gate. If we
      // don't, the opacity:0 rule is removed while Kiwi's modal is still
      // "open", and users see Kiwi's own UI pop onto the screen.
      //
      // Escape keydown isn't reliable on production (Kiwi doesn't always
      // listen for it), so we actively click Kiwi's close button and
      // any overlay/backdrop as a fallback.
      try {
        var closeBtn = document.querySelector(
          '.kiwi-sizing-modal .ks-modal-close, ' +
          '.kiwi-sizing-modal [class*="modal-close"], ' +
          '.kiwi-sizing-modal button[aria-label*="close" i], ' +
          '.kiwi-sizing-modal [class*="close-button"]'
        );
        if (closeBtn) closeBtn.click();

        // Fallback 1: dispatch Escape (some Kiwi versions listen)
        document.dispatchEvent(
          new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true })
        );

        // Fallback 2: click the overlay (usually dismisses any modal)
        var overlay = document.querySelector('.kiwi-sizing-modal-overlay, .ks-overlay');
        if (overlay) overlay.click();
      } catch (e) {}

      document.body.removeAttribute('data-size-fit-open');

      kiwiEmbedded = false;
      kiwiLiveNode = null;
      chartHost.innerHTML = '<div class="size-fit-modal__loading">Loading size chart\u2026</div>';
    }

    // ═══════════════════════════════════════════════════════════════════════
    //  TRUEFIT
    //
    //  The store's TrueFit integration (tf-integration.js) auto-injects
    //  <div id="tfc-widget" class="tfc-fitrec-product" data-styleid="…">
    //  somewhere in the page (usually inside a Shopify app-block). The
    //  styleid is TrueFit's own internal product ID, NOT the Shopify
    //  variant ID — passing the variant ID makes the iframe load blank.
    //
    //  Strategy: find #tfc-widget on page load, move it into our host
    //  when the TrueFit tab activates, move it back when the modal closes.
    //  Moving the node causes the iframe to reload once, but the styleid
    //  is already correct so the widget renders properly on production.
    // ═══════════════════════════════════════════════════════════════════════

    var truefitOrigParent = null;   // where #tfc-widget originally lived
    var truefitOrigNext = null;     // sibling to restore position on close

    function embedTrueFitIntoHost() {
      if (!truefitHost) return;
      truefitHost.innerHTML = '<div class="size-fit-modal__loading">Loading fit recommendation\u2026</div>';

      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var tfcWidget = document.getElementById('tfc-widget');
        if (tfcWidget && !truefitHost.contains(tfcWidget)) {
          clearInterval(timer);

          // Remember original location so we can put it back on close.
          // We only record the FIRST time we move it.
          if (!truefitOrigParent) {
            truefitOrigParent = tfcWidget.parentNode;
            truefitOrigNext = tfcWidget.nextSibling;
          }

          truefitHost.innerHTML = '';
          truefitHost.appendChild(tfcWidget);

          // Force show — the global `.tfc-fitrec-product { display:none }`
          // rule from the theme would otherwise hide it. Let the widget
          // self-size via its iframe's postMessage resize — don't impose
          // a min-height here or we get a huge empty box for the CTA.
          tfcWidget.style.cssText =
            'display:block !important; visibility:visible !important; width:100%;';

          return;
        }
        if (tries > 60) {   // 6s — TrueFit never injected
          clearInterval(timer);
          truefitHost.innerHTML =
            '<p class="size-fit-modal__error">Fit recommendation is temporarily unavailable.</p>';
        }
      }, 100);
    }

    function restoreTrueFit() {
      if (!truefitHost) return;
      // Put #tfc-widget back where TrueFit's script originally placed it
      // so the native integration (and any other consumers on the page)
      // finds it again on subsequent page interactions.
      var tfcWidget = truefitHost.querySelector('#tfc-widget');
      if (tfcWidget && truefitOrigParent) {
        tfcWidget.style.cssText = '';   // drop our overrides
        if (truefitOrigNext && truefitOrigNext.parentNode === truefitOrigParent) {
          truefitOrigParent.insertBefore(tfcWidget, truefitOrigNext);
        } else {
          truefitOrigParent.appendChild(tfcWidget);
        }
      }
      truefitHost.innerHTML = '';
    }

    // ── Modal open / close ───────────────────────────────────────────────

    /*
      Prime Kiwi with the RIGHT product's data before cloning its
      chart into our modal. Three contexts, in precedence order:
        1. Shop The Look — each `.lookbook-product` carries
           `[data-lookbook-kiwi-data]`; resolved from the clicked
           trigger.
        2. Quick-view — `[data-quickview-kiwi-data]` on the page
           (injected by main-product--quick.liquid).
        3. PDP — kiwiSizing.liquid already initialised Kiwi
           server-side.

      Returns the product id we primed for (or null if no prime
      ran). Always calls `loadSizing()` — even if "already primed"
      for this product — because Kiwi's own trigger link
      (`.ks-chart-modal-link`) in the DOM can go stale across
      opens and the cheapest way to refresh it is to re-load.
    */
    /*
      Kiwi's `loadSizing()` requires `options.el` + `displayMode: 1`
      — an anchor element it injects `.sizing-chart-modal-link` as
      a SIBLING of (matches the pattern in sections/collection-
      lookbook.liquid which is known working).

      Previous attempt used an off-screen hidden div, but Kiwi
      apparently needs the anchor to be a concrete element it can
      insertBefore/After against — and our embed poll then had to
      scan the WHOLE document for the link. New approach: create a
      `.size-modal`-classed host inside our chartHost. Kiwi drops
      `.sizing-chart-modal-link` right next to it, Phase-1 poll
      finds and clicks it, Phase-2 clones Kiwi's native chart
      content back into chartHost.
    */
    function getKiwiAnchor() {
      if (!chartHost) return null;
      var anchor = chartHost.querySelector('[data-kiwi-anchor]');
      if (!anchor) {
        anchor = document.createElement('div');
        anchor.className = 'size-modal';
        anchor.setAttribute('data-kiwi-anchor', '');
        anchor.setAttribute('aria-hidden', 'true');
        anchor.style.cssText =
          'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;pointer-events:none;';
        chartHost.appendChild(anchor);
      }
      return anchor;
    }

    function primeKiwiForTrigger(triggerEl) {
      var data = null;

      // 1. Lookbook — per-companion blob walked up from the trigger.
      if (triggerEl) {
        var lookbookItem = triggerEl.closest('.lookbook-product');
        if (lookbookItem) {
          var lookbookBlob = lookbookItem.querySelector('[data-lookbook-kiwi-data]');
          if (lookbookBlob) {
            try { data = JSON.parse(lookbookBlob.textContent); } catch (e) { data = null; }
          }
        }
      }

      // 2. Quick-view — page-wide blob (collection page).
      if (!data) {
        var qvBlob = document.querySelector('[data-quickview-kiwi-data]');
        if (qvBlob) {
          try { data = JSON.parse(qvBlob.textContent); } catch (e) { data = null; }
        }
      }

      // 3. PDP fallback — re-prime from the server-initialised
      //    `window.KiwiSizing.data`. Needed when the user tapped a
      //    lookbook companion's size chart (which re-primed Kiwi
      //    for the companion), closed the modal, and then tapped
      //    the PARENT PDP's Size & Fit — without this fallback,
      //    Kiwi's DOM still has the companion's
      //    `.ks-chart-modal-link` and we clone the wrong chart.
      //    Reverse case (PDP → companion) is already handled by
      //    the lookbook blob lookup above.
      if (!data && window.KiwiSizing && window.KiwiSizing.data && window.KiwiSizing.data.product) {
        data = window.KiwiSizing.data;
      }

      if (!data || !data.product) return null;

      var host = getKiwiAnchor();
      var kiwiOptions = { el: host, displayMode: 1 };

      // Kiwi app may not be loaded yet at click time on collection
      // pages (app embed bundles are deferred, and their scope can
      // exclude the collection template entirely on some Shopify
      // plans). Retry for up to 3 seconds — if it comes in, prime.
      if (!window.ks || typeof window.ks.loadSizing !== 'function') {
        var waitStart = Date.now();
        var waitTimer = setInterval(function () {
          if (window.ks && typeof window.ks.loadSizing === 'function') {
            clearInterval(waitTimer);
            try { window.ks.loadSizing({ productData: data, options: kiwiOptions }); }
            catch (e) { console.warn('[size-fit] Kiwi loadSizing threw:', e); }
          } else if (Date.now() - waitStart > 3000) {
            clearInterval(waitTimer);
            console.warn('[size-fit] window.ks never became available — Kiwi app likely not scoped to this template.');
          }
        }, 100);
        return data.product;
      }

      try {
        window.ks.loadSizing({
          productData: data,
          options: kiwiOptions
        });
      } catch (e) {
        console.warn('[size-fit] Kiwi loadSizing threw:', e);
      }
      return data.product;
    }

    // Tracks which product's chart-modal-link is currently in the
    // DOM. Used by openModal() to wipe stale `.ks-chart-modal-link`
    // nodes before the embed poll, so Shop-the-Look's first tap
    // doesn't clone the PDP's chart.
    var lastEmbeddedProductId = null;

    function openModal(triggerEl) {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTab('chart');

      /*
        Lookbook / Shop-the-Look context: the CTA normally proxies
        to the PARENT PDP's add-to-cart button, which would add the
        wrong product when the modal was opened from a lookbook
        companion. We instead flag the trigger context on `modal`
        and the CTA syncer branches on it — in lookbook mode the
        CTA reads the lookbook companion's selected radio and
        POSTs directly to `/cart/add.js` with that variant id.
        See the `(function(){ ... })();` CTA block below.
      */
      var companionEl = triggerEl && triggerEl.closest('.lookbook-product, [data-lookbook-product], .shop-the-look-product');
      if (companionEl) {
        modal.setAttribute('data-context', 'lookbook');
        // Cache a reference key — we can't store DOM refs on
        // dataset, so we use the companion's id attr if present,
        // and look it up at CTA time by the same selector.
        var cid = companionEl.getAttribute('data-product-id') || companionEl.id || '';
        modal.setAttribute('data-context-id', cid);
        window.__sizeFitCompanionEl = companionEl;
      } else {
        modal.setAttribute('data-context', 'primary');
        modal.removeAttribute('data-context-id');
        window.__sizeFitCompanionEl = null;
      }
      // Ensure CTA row visible — previous pass hid it in lookbook
      // mode, but we now handle lookbook with a real add-to-cart
      // path instead.
      var ctaRow = modal.querySelector('.size-fit-modal__cta-row');
      if (ctaRow) ctaRow.hidden = false;

      /*
        Force a CTA re-sync on every open — otherwise the label
        stays at its last-computed value (usually the primary PDP's
        price), which is wrong when the modal was just opened from
        a lookbook trigger. User-visible bug: opened lookbook Size
        & Fit for "Andheri Raat Denim Pants" (Rs.48,200), CTA
        still read "ADD TO BAG — Rs.34,900 PKR" because it was
        left over from the main hoodie context. Calling syncCta
        here makes the label reflect the CURRENT context
        immediately — "SELECT A SIZE" if no companion variant is
        chosen, or the companion's own price once one is.

        Ditto for primary context: if the PDP variant is mid-
        transition or was unset, syncCta will re-read the primary
        ATC and render accordingly.
      */
      if (typeof window.__sizeFitSyncCta === 'function') {
        window.__sizeFitSyncCta();
      }

      /*
        CRITICAL ORDERING: wipe chartHost BEFORE priming.

        Earlier iteration had prime → wipe → poll, but `prime`
        creates the Kiwi anchor inside chartHost and then calls
        `loadSizing({el: anchor})`. The subsequent innerHTML wipe
        destroyed the anchor before Kiwi had a chance to inject the
        `.sizing-chart-modal-link` alongside it, so the Phase-1 poll
        scanned `document.querySelector('.ks-chart-modal-link')`
        and found nothing — chart never rendered. On first open
        after page load, `lastEmbeddedProductId` is null so any
        primed product id triggers `productChanged` → wipe runs →
        bug fires. That's the regression the user flagged.

        Fix: stale-state cleanup runs FIRST, then prime creates a
        fresh anchor in the now-clean chartHost, and the loadSizing
        call lands against a stable DOM reference.

        For "same-product re-open" (productChanged === false) we
        skip the wipe entirely so the clone from the previous open
        stays put and renders instantly.
      */
      var willPrime = (function () {
        // Cheap pre-check: does the trigger context carry a blob
        // we'd prime from? Mirrors primeKiwiForTrigger's precedence.
        if (triggerEl) {
          var l = triggerEl.closest('.lookbook-product');
          if (l && l.querySelector('[data-lookbook-kiwi-data]')) return true;
        }
        if (document.querySelector('[data-quickview-kiwi-data]')) return true;
        return !!(window.KiwiSizing && window.KiwiSizing.data && window.KiwiSizing.data.product);
      })();

      if (willPrime && chartHost) {
        // Strip stale `.ks-chart-modal-link` anywhere in the doc so
        // the Phase-1 poll can't pick up the previous product's
        // link. Also drop any cached live-node/clone reference.
        var staleLinks = document.querySelectorAll(
          '.ks-chart-modal-link:not([data-size-fit-kept]), ' +
          '.sizing-chart-modal-link:not([data-size-fit-kept])'
        );
        staleLinks.forEach(function (el) { el.parentNode && el.parentNode.removeChild(el); });
        if (kiwiEmbedded) restoreKiwi();
        kiwiEmbedded = false;
        kiwiLiveNode = null;
        chartHost.innerHTML = '<div class="size-fit-modal__loading">Loading size chart…</div>';
      }

      var primedProductId = primeKiwiForTrigger(triggerEl);
      var productChanged = primedProductId && primedProductId !== lastEmbeddedProductId;

      // 250 ms deferral on product change lets Kiwi finish its
      // async fetch + DOM injection before our poll starts —
      // prevents the poll from picking up the PREVIOUS product's
      // link (which may not have been GC'd yet).
      var wait = productChanged ? 250 : 0;
      setTimeout(function () {
        if (primedProductId) lastEmbeddedProductId = primedProductId;
        embedKiwiIntoHost();
      }, wait);
    }

    function closeModal() {
      // Blur any focused descendant BEFORE flipping aria-hidden.
      // Otherwise the browser logs "Blocked aria-hidden on an
      // element because its descendant retained focus" and — in
      // some browser versions — refuses to dismiss the modal
      // properly, leaving the modal in a half-open state where
      // subsequent open clicks appear to do nothing. Root cause of
      // the user's "once it bugs out it does nothing on click"
      // symptom on quick-view.
      if (document.activeElement && modal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      restoreKiwi();
      restoreTrueFit();
    }

    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-open-size-fit]');
      if (openTrigger) {
        e.preventDefault();
        // Try to re-bind if the modal wasn't present at page load
        // (collection page → quick-view injection path).
        if (!modal && !bindModal()) return;
        openModal(openTrigger);
        return;
      }
      if (e.target.closest('[data-size-fit-close]')) {
        e.preventDefault();
        if (!modal) return;
        closeModal();
        return;
      }
      var tab = e.target.closest('[data-size-fit-tab]');
      if (tab) {
        e.preventDefault();
        if (!modal && !bindModal()) return;
        setTab(tab.getAttribute('data-size-fit-tab'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    // ═══════════════════════════════════════════════════════════════════════
    //  Size & Fit CTA — mirror primary ATC
    //
    //  The modal renders a persistent "ADD TO BAG — $PRICE" button at the
    //  bottom of the sheet. Behaviour is the same pattern as
    //  snippets/product-sticky-atc.liquid: click proxies to the primary
    //  `[data-product-form] [data-add-to-cart]` so Stiletto's ProductForm
    //  bindings run; label / disabled mirror from the primary on
    //  `product:variant-change` plus a MutationObserver on the primary.
    //
    //  Label composition differs from the sticky ATC: we append the
    //  CURRENT variant's money-formatted price (read from
    //  `document.querySelector('[data-product-price]')`) because the
    //  Represent-style CTA reads "ADD TO BAG — RS.35,000.00 PKR".
    // ═══════════════════════════════════════════════════════════════════════
    (function () {
      function primaryAtc() {
        return document.querySelector('[data-product-form] [data-add-to-cart]');
      }
      // Strip a trailing `.00` (with optional decimal-thousands variants
      // like `,00`) off a money-formatted string. The PDP header price
      // is rendered via Liquid's `money` filter which always emits
      // `.00` on whole numbers; the modal's Liquid initial label uses
      // `money_without_trailing_zeros` so we want the live JS-synced
      // label to match. User feedback: "Add to bag in the modal
      // shouldn't have decimal price either."
      function stripTrailingZeros(price) {
        if (!price) return price;
        // Handles `$120.00`, `Rs.35,000.00`, `$120.00 PKR` — the decimal
        // separator can be `.` or `,` depending on locale. Match a
        // `.00` / `,00` that's immediately after a digit and either
        // at end-of-string or followed by a space + currency code.
        return price.replace(/([0-9])[.,]00(\b|$)/, '$1$2');
      }
      function currentPriceText() {
        // Stiletto renders the active-variant price into the PDP
        // header's `.product__price [data-price]` element and updates
        // it on variant change before `product:variant-change` fires.
        // Scope the selector to the header block so we don't pick up
        // `[data-price]` on product cards elsewhere on the page.
        var priceEl = document.querySelector('.product__price [data-price]');
        if (priceEl && priceEl.textContent) {
          var txt = priceEl.textContent.replace(/\s+/g, ' ').trim();
          if (txt) {
            // PDP doesn't suffix the currency code onto the price
            // display on PK storefronts (we only suffix in cart). If
            // the Liquid-rendered fallback on the modal carries a
            // suffix, lift it onto the live-read price so the CTA
            // stays consistent.
            var modalEl = document.querySelector('[data-size-fit-modal]');
            var fallback = (modalEl && modalEl.dataset.fallbackPrice) || '';
            var m = fallback.match(/\s([A-Z]{3})$/);
            if (m && txt.indexOf(m[1]) === -1) txt += ' ' + m[1];
            return stripTrailingZeros(txt);
          }
        }
        var ctaModal = document.querySelector('[data-size-fit-modal]');
        return stripTrailingZeros((ctaModal && ctaModal.dataset.fallbackPrice) || '');
      }

      function composeLabel(primary) {
        // Read the primary button's live label; if the primary is in
        // an "unavailable / sold out" state we echo that directly
        // (no price suffix, matches the sticky ATC pattern).
        if (!primary) return '';
        var disabled = primary.getAttribute('aria-disabled') === 'true' || primary.disabled;
        var labelSpan = primary.querySelector('[data-add-to-cart-text]');
        var base = labelSpan ? labelSpan.textContent.trim() : primary.textContent.trim();
        base = (base || '').toUpperCase();
        if (disabled) return base;
        var price = currentPriceText();
        return price ? base + ' — ' + price : base;
      }

      /*
        Lookbook-context helpers. When the modal was opened from a
        Shop-the-Look trigger we don't proxy to the primary ATC —
        we read the companion-product's selected variant radio and
        compose the CTA against IT. CTA click posts to /cart/add.js
        directly with that variant id; if no size is selected the
        CTA is disabled with "SELECT A SIZE".
      */
      function currentCompanionEl() {
        var modalEl = document.querySelector('[data-size-fit-modal]');
        if (!modalEl || modalEl.getAttribute('data-context') !== 'lookbook') return null;
        return window.__sizeFitCompanionEl || null;
      }
      function companionSelectedVariant() {
        var comp = currentCompanionEl();
        if (!comp) return null;
        var checked = comp.querySelector('input[type="radio"][name*="variant"]:checked');
        if (!checked) return null;
        return {
          id: checked.value,
          price: parseInt(checked.getAttribute('data-price'), 10) || 0,
          available: !checked.disabled,
          title: (checked.nextElementSibling && checked.nextElementSibling.textContent.trim()) || ''
        };
      }
      function companionMoneyFormat() {
        // Inline literal from Liquid would be cleaner; since this
        // asset loads once, just reuse Shopify's global if present.
        return (window.theme && window.theme.moneyFormat) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.format) || '${{amount}}';
      }
      function formatMoneyCents(cents) {
        var n = Math.round(cents);
        var fmt = companionMoneyFormat();
        var re = /\{\{\s*(\w+)\s*\}\}/;
        var m = fmt.match(re);
        if (!m) return (n / 100).toFixed(0);
        var kind = m[1];
        var s;
        if (kind === 'amount_no_decimals' || kind === 'amount_no_decimals_with_comma_separator') {
          s = Math.round(n / 100).toString().replace(/(\d)(?=(\d{3})+$)/g, kind.indexOf('comma') !== -1 ? '$1.' : '$1,');
        } else {
          s = (n / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        }
        return stripTrailingZeros(fmt.replace(re, s));
      }

      function syncCta() {
        var modalEl = document.querySelector('[data-size-fit-modal]');
        if (!modalEl) return;
        var cta = modalEl.querySelector('[data-size-fit-cta]');
        var ctaLabel = modalEl.querySelector('[data-size-fit-cta-label]');
        if (!cta || !ctaLabel) return;

        // Lookbook context: label + state derived from companion radio.
        if (modalEl.getAttribute('data-context') === 'lookbook') {
          var v = companionSelectedVariant();
          if (!v) {
            ctaLabel.textContent = 'SELECT A SIZE';
            cta.setAttribute('disabled', '');
            cta.setAttribute('aria-disabled', 'true');
            return;
          }
          if (!v.available) {
            ctaLabel.textContent = 'SOLD OUT';
            cta.setAttribute('disabled', '');
            cta.setAttribute('aria-disabled', 'true');
            return;
          }
          var priceStr = v.price ? formatMoneyCents(v.price) : '';
          ctaLabel.textContent = priceStr ? 'ADD TO BAG — ' + priceStr : 'ADD TO BAG';
          cta.removeAttribute('disabled');
          cta.removeAttribute('aria-disabled');
          return;
        }

        // Primary PDP context: mirror primary ATC label / state.
        var primary = primaryAtc();
        if (!primary) return;
        ctaLabel.textContent = composeLabel(primary);
        var disabled = primary.getAttribute('aria-disabled') === 'true' || primary.disabled;
        if (disabled) {
          cta.setAttribute('disabled', '');
          cta.setAttribute('aria-disabled', 'true');
        } else {
          cta.removeAttribute('disabled');
          cta.removeAttribute('aria-disabled');
        }
      }

      // Click proxy — branches on modal context.
      document.addEventListener('click', function (e) {
        var cta = e.target.closest('[data-size-fit-cta]');
        if (!cta) return;
        e.preventDefault();
        if (cta.getAttribute('aria-disabled') === 'true' || cta.disabled) return;

        var modalEl = document.querySelector('[data-size-fit-modal]');
        if (modalEl && modalEl.getAttribute('data-context') === 'lookbook') {
          var v = companionSelectedVariant();
          if (!v || !v.available) return;
          cta.setAttribute('disabled', '');
          cta.setAttribute('aria-disabled', 'true');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
            .then(function () {
              // Refresh the quick-cart drawer + let Stiletto know.
              document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('theme:cart:updated', { bubbles: true }));
              // Close our modal; the cart drawer should open via
              // Stiletto's cart:item-added listener chain.
              if (typeof closeModal === 'function') closeModal();
            })
            .catch(function () {
              cta.removeAttribute('disabled');
              cta.removeAttribute('aria-disabled');
            });
          return;
        }

        // Primary path.
        var primary = primaryAtc();
        if (!primary) return;
        if (primary.getAttribute('aria-disabled') === 'true' || primary.disabled) return;
        primary.click();
      });

      // Re-sync CTA when lookbook radio selection changes.
      document.addEventListener('change', function (e) {
        var r = e.target && e.target.closest('.lookbook-product input[type="radio"][name*="variant"]');
        if (!r) return;
        syncCta();
      });

      // Initial sync + re-sync on variant change.
      document.addEventListener('product:variant-change', syncCta);

      // ── Close the Size & Fit modal after a successful add ─────────
      //
      // Stiletto dispatches `cart:item-added` from assets/theme.js
      // (dispatchCustomEvent, ~line 6600) only after a successful
      // ajax add — errors dispatch `cart:error` instead, and qty
      // changes / removals go through `cart:updated`. So listening
      // specifically to `cart:item-added` is the correct signal for
      // "the user successfully added via our modal's CTA; dismiss
      // the modal so the cart drawer or next action isn't covered".
      //
      // We guard so we only close if our modal is currently open —
      // otherwise any add from anywhere on the page would trigger a
      // no-op close with side-effects (restoreKiwi, body scroll
      // unlock) that might conflict with other UI.
      //
      // User feedback: "when you click add to bag in our modal it
      // doesn't disappear it just stays there".
      document.addEventListener('cart:item-added', function () {
        var m = document.querySelector('[data-size-fit-modal]');
        if (!m || m.hidden) return;
        // Defer one microtask so Stiletto's own post-add handlers
        // (open cart drawer, update badge, etc.) get to run against
        // the modal still being open — closing synchronously inside
        // the dispatch loop is technically fine but the microtask
        // keeps ordering predictable.
        Promise.resolve().then(function () {
          if (typeof closeModal === 'function' && !m.hidden) closeModal();
        });
      });

      // Expose syncCta for cross-IIFE callers (openModal, external).
      window.__sizeFitSyncCta = syncCta;

      var moRetries = 0;
      function tryAttachObserver() {
        var primary = primaryAtc();
        if (!primary) {
          if (moRetries++ < 10) setTimeout(tryAttachObserver, 300);
          return;
        }
        syncCta();
        if ('MutationObserver' in window) {
          var mo = new MutationObserver(syncCta);
          mo.observe(primary, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['disabled', 'aria-disabled']
          });
        }
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tryAttachObserver, { once: true });
      } else {
        tryAttachObserver();
      }
    })();

    /*
      PDP price-decimal regression on variant change.

      Liquid renders the PDP header's `[data-price]` via
      `money_without_trailing_zeros`, so the initial markup is clean
      (no `.00`). BUT Stiletto's `updatePrices()` (assets/theme.js
      L5245) calls `el.innerHTML = formatMoney(variant.price)` on
      every variant change — `formatMoney` uses the raw money format
      string which always emits `.00` on whole numbers. Result:
      fresh page → clean price, select a different variant → `.00`
      returns.

      Fix: observe mutations on `.product__price [data-price]` (and
      its sibling compare-at `[data-compare-price]`) and strip
      `.00` / `,00` whenever they appear. Cheap, self-contained,
      no monkey-patch needed.
    */
    (function () {
      function stripZerosIn(el) {
        if (!el || !el.textContent) return;
        var was = el.textContent;
        var cleaned = was.replace(/([0-9])[.,]00(\b|$)/, '$1$2');
        if (cleaned !== was) el.textContent = cleaned;
      }
      function stripAll() {
        document.querySelectorAll('.product__price [data-price], .product__price [data-compare-price], [data-size-fit-cta-label]').forEach(stripZerosIn);
      }
      function attachPdpPriceObserver() {
        var targets = document.querySelectorAll('.product__price [data-price], .product__price [data-compare-price]');
        if (!targets.length) return false;
        targets.forEach(function (el) {
          stripZerosIn(el);
          if ('MutationObserver' in window) {
            var mo = new MutationObserver(function () { stripZerosIn(el); });
            mo.observe(el, { childList: true, characterData: true, subtree: true });
          }
        });
        return true;
      }
      var priceTries = 0;
      function boot() {
        if (!attachPdpPriceObserver() && priceTries++ < 10) {
          setTimeout(boot, 300);
        }
      }
      document.addEventListener('product:variant-change', stripAll);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
      } else {
        boot();
      }
    })();
  })();

  /**
   * Consolidated conversion-info ordering. The Enclave rewards block
   * renders above the size pills by default (position set in theme
   * editor). Move it DOWN into the same container as the stock /
   * free-shipping items, at the top of the list — so the status
   * paragraph reads: Enclave → In Stock → Free shipping.
   */
  (function () {
    // Formerly: `reorder()` moved `.product__rewards` into
    // `.product-stock-shipping-info` on DOMContentLoaded. This
    // caused the enclave-points + size-pills flash the user flagged
    // — the rewards row would render at its natural position above
    // the size pills, THEN visibly jump into the callout list after
    // first paint. Now that reordering happens at Liquid time (see
    // snippets/product-block-stock-and-shipping-info.liquid + the
    // pre-scan in snippets/product-blocks.liquid), no JS reshuffle
    // is required.
    //
    // Left as a safety net: if the Liquid-time hoist didn't run
    // (unusual merchandiser setup, section re-render where the
    // pre-scan context was lost, etc.) we still reorder at runtime
    // so the design intent is preserved. Guarded by the existing
    // `data-conversion-block-moved` flag so it can't fight the
    // Liquid render.
    if (window.__convInfoReorderInit) return;
    window.__convInfoReorderInit = true;
    function reorder() {
      var rewards   = document.querySelector('.product__rewards');
      var stockShip = document.querySelector('.product-stock-shipping-info');
      if (!rewards || !stockShip) return;
      // If the Liquid render already placed rewards inside
      // stock-shipping-info, there's nothing to do.
      if (stockShip.contains(rewards)) return;
      if (rewards.dataset.conversionBlockMoved) return;
      stockShip.insertBefore(rewards, stockShip.firstChild);
      rewards.dataset.conversionBlockMoved = '1';
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorder);
    } else {
      reorder();
    }
  })();
